import { HandledSubmitFormError } from "@customTypes/ErrorMessagesTypes";

export const handleSubmitFormErrors = (
  response,
  apiErrorMessages: HandledSubmitFormError = {}
): Array<string> | null => {
  let errorMessages: Array<string> = apiErrorMessages["GENERIC_MESSAGE"]
    ? [apiErrorMessages["GENERIC_MESSAGE"]]
    : [];

  if (response?.errors) {
    errorMessages = response.errors.map(
      (error) => apiErrorMessages[error.errorCode]
    );
  } else if (response?.errorCode) {
    errorMessages = [apiErrorMessages[response.errorCode]];
  }
  const errorMessage = errorMessages.filter((value, index, self) => {
    return self.indexOf(value) === index;
  });

  return errorMessage.length ? errorMessage : ["Something went wrong"];
};
